// @flow
import React from 'react';
import Experiment from '@homeaway/react-experiment';
import {
    HA_SERP_SEARCHFORM_COMPONENT_V2,
    HA_SERP_SEARCHFORM_ROLLOUT
} from '../../abacus/experiments';
import SearchBar from '../SearchBar/SearchBar';
import SearchFormContainer from '../SearchFormContainer/SearchFormContainer';

function SearchFormExperimentWrapper() {
    return (
        <Experiment name={HA_SERP_SEARCHFORM_ROLLOUT}>
            {({On: SearchFormRolloutOn, Off: SearchFormRolloutOff}) => (
                <>
                    <SearchFormRolloutOn>
                        <SearchFormContainer />
                    </SearchFormRolloutOn>
                    <SearchFormRolloutOff>
                        <Experiment name={HA_SERP_SEARCHFORM_COMPONENT_V2}>
                            {({
                                On: SearchFormComponentV2On,
                                Off: SearchFormComponentV2Off
                            }) => (
                                <>
                                    <SearchFormComponentV2On>
                                        <SearchFormContainer />
                                    </SearchFormComponentV2On>
                                    <SearchFormComponentV2Off>
                                        <SearchBar />
                                    </SearchFormComponentV2Off>
                                </>
                            )}
                        </Experiment>
                    </SearchFormRolloutOff>
                </>
            )}
        </Experiment>
    );
}

export default SearchFormExperimentWrapper;
